import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

import { catchError, concatAll, forkJoin, lastValueFrom, Observable, of, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private authService: OAuthService, private http: HttpClient) {

  }
  loggedIn: boolean = false
  isMsal: boolean = false
  authLoaded = new Object()
  auths = new Object()

  doRefresh: Number

  isLoggedIn(): boolean {
    return true
  }
  get idToken(){
    return this.authService.getIdToken()
  }
  logon(user: string, password: string): boolean {
    this.loggedIn = true;
    return true
  }
  setLoggedOn(loggedOn: boolean) {
    this.loggedIn = loggedOn;
  }
  setMsal(isMsal: boolean) {
    this.isMsal = isMsal
    /*this.getMsalToken().then(
      data => this.idToken = data
    )*/
  }

  get accessToken(){
    return this.authService.getAccessToken()
  }
  setIdToken(token: string) {
    
    console.log("setIdToken TOKEN!!!!" + token)
  }

  getUserFromMsal(): string {
    
    console.log("BASE URI " + document.baseURI)
    let claims = this.authService.getIdentityClaims()
    if(!claims){
      console.log("NO CLAIMS")
      return ""
    }
    else{
      return claims["name"]
    }

  }

  getOIDFromMsal(): string {
    let claims = this.authService.getIdentityClaims()
    if(!claims){
      console.log("NO CLAIMS")
      return ""
    }
    else{
      return claims["oid"]
    }

  }

  logout() {
    this.authService.revokeTokenAndLogout()
  }



  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

  login() {
    
  }

  async getAuth(auth: string, userID: string) {
    if (this.authLoaded && this.authLoaded[auth]) {
      if (this.auths[auth]) {
        return true
      } else {
        return false
      }
    }
    await lastValueFrom(this.getAuths(userID, this))
    if (this.auths[auth]) {
      return true
    } else {
      return false
    }
  }

  async getAuthForLoggedOnUser(auth: string) {
    if (this.authLoaded && this.authLoaded[auth]) {
      if (this.auths[auth]) {
        console.log("AUTH " + auth + " RES " + true)
        return true
      } else {
        console.log("AUTH " + auth + " RES " + false)
        return false
      }
    }
    let userID = this.getOIDFromMsal()
    await lastValueFrom(this.getAuths(userID, this))
    if (this.auths[auth]) {
      console.log("AUTH " + auth + " RES " + true)
      return true
    } else {
      console.log("AUTH " + auth + " RES " + false)
      return false
    }
  }

  /*
  getAuthObs(auth: string, userID: string) {
    if (this.authLoaded && this.authLoaded[auth]) {
      if (this.auths[auth]) {
        return true
      } else {
        return false
      }
    }
    await lastValueFrom(this.getAuths(userID,this))
    if (this.auths[auth]) {
      return true
    } else {
      return false
    }
  }
  */
  getAuths(userID: string, ctrl) {
    let url = '/access-control/auth/' + userID + '/process/orders-purchaseorder-mass/operation/edit'
    let authArr$ = []
    let auth1$ = this.http.get(url).pipe(
      tap(data => {
        ctrl.auths["po-mass"] = true
        ctrl.authLoaded["po-mass"] = true
      }),
      catchError(
        err => {
          if (err["status"] == 404) {
            ctrl.authLoaded["po-mass"] = true
          }
          return of([])
        }
      )
    )
    authArr$.push(auth1$)
    url = '/access-control/auth/' + userID + '/process/orders-purchaseorder/operation/edit'
    let auth2$ = this.http.get(url).pipe(
      tap(data => {
        ctrl.auths["po-edit"] = true
        ctrl.authLoaded["po-edit"] = true
      }),
      catchError(
        err => {
          if (err["status"] == 404) {
            this.authLoaded["po-edit"] = true
          }
          return of([])
        }
      )
    )
    authArr$.push(auth2$)
    url = '/access-control/auth/' + userID + '/process/allocation-order/operation/edit'
    let auth3$ = this.http.get(url).pipe(
      tap(data => {
        ctrl.auths["allocation-edit"] = true
        ctrl.authLoaded["allocation-edit"] = true
      }),
      catchError(
        err => {
          if (err["status"] == 404) {
            this.authLoaded["allocation-edit"] = true
          }
          return of([])
        }
      )
    )
    authArr$.push(auth3$)
    url = '/access-control/auth/' + userID + '/process/allocation-order/operation/show'
    let auth4$ = this.http.get(url).pipe(
      tap(data => {
        ctrl.auths["allocation-show"] = true
        ctrl.authLoaded["allocation-show"] = true
      }),
      catchError(
        err => {
          if (err["status"] == 404) {
            this.authLoaded["allocation-show"] = true
          }
          return of([])
        }
      )
    )
    authArr$.push(auth4$)
    url = '/access-control/auth/' + userID + '/process/allocation-order/operation/execute'
    let auth5$ = this.http.get(url).pipe(
      tap(data => {
        ctrl.auths["allocation-exec"] = true
        ctrl.authLoaded["allocation-exec"] = true
      }),
      catchError(
        err => {
          if (err["status"] == 404) {
            this.authLoaded["allocation-exec"] = true
          }
          return of([])
        }
      )
    )
    authArr$.push(auth5$)


    return forkJoin({
      'mass': auth1$, 'po-edit': auth2$, 'allocation-edit': auth3$,
      'allocation-show': auth4$, 'allocation-exec': auth5$
    })


  }


}